export default __webpack_public_path__ + "static/media/office.c260f996.jpg";